module.exports = __webpack_public_path__ + "static/tyrant05-sq-b3421e640d3c11538b7b066f158ee08c.png";